<template>
  <div class="app-container">
    <div class="detail-header">
      <span class="title">旧机详情</span>
    </div>
    <el-form label-position="left" :label-width="'140px'" class="detail-form">
      <div class="section">门店信息</div>
      <el-form-item label="门店名称">{{ detail.storeName }}</el-form-item>
      <el-form-item label="所在省">{{ detail.provinceName }}</el-form-item>
      <el-form-item label="所在市">{{ detail.cityName }}</el-form-item>

      <div class="section">用户信息</div>
      <el-form-item label="姓名">{{ detail.contactName }}</el-form-item>
      <el-form-item label="身份证号">
        <span>{{ detail.idCard }}</span>
        <img
          v-if="detail.idCard"
          :src="dataVisible.idCard ? eyeOpen : eyeClose"
          class="eye"
          @click="toggleVisibility('idCard')"
        />
      </el-form-item>
      <el-form-item label="联系电话">
        <span>{{ detail.contactMobile }}</span>
        <img
          v-if="detail.contactMobile"
          :src="dataVisible.contactMobile ? eyeOpen : eyeClose"
          class="eye"
          @click="toggleVisibility('contactMobile')"
        />
      </el-form-item>
      <el-form-item label="用户地址">{{ fullAddress }}</el-form-item>

      <div class="section">新机信息</div>
      <el-form-item label="新机品牌">{{ detail.newBrand }}</el-form-item>
      <el-form-item label="新机型号">{{ detail.newMachineModel }}</el-form-item>
      <el-form-item label="新机铭牌编号">{{ detail.newNameplateNo }}</el-form-item>
      

      <div class="section">旧机信息</div>
      <el-form-item label="回收品类">{{ detail.categoryName }}</el-form-item>
      <el-form-item label="旧机品牌/系列">{{ detail.brand }}</el-form-item>
      <el-form-item label="旧机型号">{{ detail.oldMachineModel }}</el-form-item>
      <el-form-item label="旧机铭牌编号">{{ detail.nameplateNo }}</el-form-item>

      <el-form-item label="旧机材质">{{ detail.materialType != null ? (detail.materialType == 1 ? '铜' : '非铜') : '--' }}</el-form-item>
      <el-form-item label="旧机功率">{{ detail.power }}</el-form-item>
      <el-form-item label="旧机是否完整">{{ detail.whole == 1 ? '是' : '否' }}</el-form-item>
      <el-form-item label="购置年份">{{ detail.purchaseYear }}</el-form-item>
      <el-form-item label="设备现状">{{ detail.deviceStatus }}</el-form-item>
      <el-form-item label="旧机条码">{{ detail.barcode }}</el-form-item>
      <el-form-item label="旧机图片">
        <div class="img-list">
          <image-upload class="img-box" :editMode="false" v-for="(item, index) in oldMachineImages" :key="index" :imageUrl.sync="item" />

          <span v-if="!oldMachineImages.length">无</span>
        </div>
      </el-form-item>
      <el-form-item label="备注">{{ detail.remark || '无' }}</el-form-item>

      <div class="section">抽检信息</div>
      <el-form-item label="是否一致">{{ consistentMap[detail.consistent] }}</el-form-item>
      <el-form-item label="抽检照片">
        <div class="img-list">
          <span v-if="!checkImages.length">无</span>
          <image-upload class="img-box" :editMode="false" v-for="(item, index) in checkImages" :key="index" :imageUrl.sync="item" />
        </div>
      </el-form-item>
      <el-form-item label="抽检备注">{{ (detail.checkLogs && detail.checkLogs.length && detail.checkLogs[0].remark) || '无' }}</el-form-item>
      
      <div class="section">师傅信息</div>
      <el-form-item label="师傅信息">{{ detail.recycleWorker }}</el-form-item>
      <el-form-item label="师傅电话">{{ detail.recyclePhone }}</el-form-item>
      
    </el-form>
    <el-button size="medium" @click="goBack" >返回</el-button>
  </div>
</template>
<script>
import eyeOpen from "@/assets/eye-open.png";
import eyeClose from "@/assets/eye-close.png";
import { getOldDeviceDetail } from "@/api/thirdPartyTradeIn";
import imageUpload from '@/components/Upload/ImageUpload'
export default {
  name: "oldDeviceDetail",
  components: {
    imageUpload
  },
  data() {
    return {
      eyeOpen,
      eyeClose,
      detail: {},
      originData: {},
      oldMachineImages: [],
      checkImages: [],
      idCardSensitization: null,
      contactMobileSensitization: null,
      dataVisible: {
        idCard: false,
        contactMobile: false
      },
      statusMap: {
        0: "已登记",
        1: "已返厂"
      },
      consistentMap: {
        1: "是",
        0: "否"
      }
    };
  },
  computed: {
    // 地址由省/市/区县/详细地址组成
    fullAddress() {
      const { provinceName, cityName, districtName, detailAddress } = this.detail;
      return [provinceName, cityName, districtName, detailAddress].filter(Boolean).join("");
    }
  },
  methods: {
    getId() {
      return this.$route.query.id;
    },
    async getDetail() {
      const id = this.getId();
      if (!id) {
        this.$message.warning("参数异常，无法查看详情");
        return;
      }
      let { statusCode, data } = await getOldDeviceDetail(id);
      if (statusCode == 200) {
        this.detail = data || {};
        this.originData = data ? { ...data } : {};
        // 解析附件（annexType: 100-旧机照片 101-抽检图片）
        const annexList = (data && data.annexList) || [];
        this.oldMachineImages = annexList.filter(item => item.annexType === 100).map(item => item.annexId)|| [];
        this.checkImages = annexList.filter(item => item.annexType === 101).map(item => item.annexId) || [];
        // 解析脱敏字段
        // 脱敏code形如"字段_类型"，如 contactMobile_phone、idCard_idCard，兼容仅字段名的情况
        const desensions = (data && data.desensitizationDtoList) || [];
        desensions.forEach(item => {
          const code = item.sensitizationCode || "";
          if (code === "idCard" || code === "idNumber" || code.startsWith("idCard_")) {
            this.idCardSensitization = item;
          }
          if (code === "contactMobile" || code === "phone" || code.startsWith("contactMobile_") || code.startsWith("phone_")) {
            this.contactMobileSensitization = item;
          }
        });
      }
    },
    // 获取脱敏源数据（明文）
    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data;
        }
      });
    },
    // 切换脱敏显示
    toggleVisibility(dataType) {
      this.dataVisible[dataType] = !this.dataVisible[dataType];
      if (dataType === "idCard") {
        if (this.dataVisible.idCard && this.idCardSensitization) {
          this.getSourceOrigin(this.idCardSensitization).then(res => {
            this.$set(this.detail, "idCard", res);
          });
        } else {
          this.$set(this.detail, "idCard", this.originData.idCard);
        }
      } else if (dataType === "contactMobile") {
        if (this.dataVisible.contactMobile && this.contactMobileSensitization) {
          this.getSourceOrigin(this.contactMobileSensitization).then(res => {
            this.$set(this.detail, "contactMobile", res);
          });
        } else {
          this.$set(this.detail, "contactMobile", this.originData.contactMobile);
        }
      }
    },
    goBack() {
      this.$router.back();
    }
  },
  mounted() {
    this.getDetail();
  }
};
</script>
<style scoped lang="scss">
.detail-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .title {
    font-size: 16px;
    font-weight: 600;
    margin-left: 16px;
  }
}
.detail-form {
  .section {
    font-size: 15px;
    font-weight: 600;
    color: #29b26b;
    margin: 20px 0 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e8eaec;
  }
  .eye {
    width: 16px;
    height: 16px;
    margin-left: 8px;
    cursor: pointer;
    vertical-align: middle;
  }
  .img-list {
    display: flex;
    flex-wrap: wrap;
    .img-item {
      width: 100px;
      height: 100px;
      margin-right: 10px;
      border: 1px solid #e8eaec;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/thirdPartyTradeIn/oldDeviceQuery/detail.vue